<template>
  <div>
    <v-select
      :items="computedItems"
      dense
      hide-details
      v-model="innerValue"
      solo
      outlined
      clearable
      :color="currentPageAttr.data.attr.style.color"
      :background-color="currentPageAttr.data.attr.style.backgroundColor"
    />
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    value: String,
    max: Number,
    currentPageAttr: Object,
  },
  data() {
    return {
      innerValue: this.value,
      disable: false,
    };
  },
  computed: {
    disableMe() {
      if (this.innerValue && this.innerValue.length >= this.max) {
        return true;
      }
      return false;
    },
    computedItems() {
      return this.items.filter((item) => item.inStock);
    },
  },
  methods: {
    contains(item) {
      const selectedItems =
        typeof this.innerValue === "string"
          ? [this.innerValue]
          : this.innerValue;
      return selectedItems.includes(item);
    },
  },
  watch: {
    innerValue(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      this.innerValue = newValue;
    },
  },
};
</script>
